import React, { ReactElement } from 'react';
import Separator from '../components/separator';

type Props = {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};

function ToolsSection(props: Props): ReactElement {
  return (
    <>
      <h3 className="padded">{props.title}</h3>
      <Separator />
      <div className="padded">{props.children}</div>
    </>
  );
}

export default ToolsSection;
